import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

// Generic report fetcher: expects { reportType, params }
// Mapping reportType key -> endpoint
const REPORT_ENDPOINTS = {
  // Báo cáo phiếu khám
  "phieu-kham": "report/consultations",
  // Báo cáo khách hàng
  "khach-hang": "report/revenue/by-customer",
  // Bán hàng
  "banhang-doanhthu": "report/overview-revenue",
  "banhang-doanhthu-chitiet": "report/detail-revenue",
  "banhang-doanhthu-dichvu": "report/revenue/by-service",
  "banhang-doanhthu-nhomdichvu": "report/revenue/by-service-category",
  // Báo cáo bác sĩ
  "bacsi-doanhthu": "report/revenue/by-doctor",
  // Báo cáo doanh thu bán hàng theo bác sĩ
  "bacsi-doanhthu-banhang": "report/revenue/service-by-doctor",
  // Báo cáo doanh thu theo người giới thiệu
  "nguoigioithieu-doanhthu": "report/revenue/by-referrer",
  // Báo cáo doanh theo người thực hiện
  "nguoithuchien-doanhthu": "report/revenue/by-responsible",
};

export const fetchReport = createAsyncThunk("report/fetchReport", async ({ reportType, params = {} }, { rejectWithValue }) => {
  const url = REPORT_ENDPOINTS[reportType];
  if (!url) {
    return rejectWithValue("Không tìm thấy endpoint cho reportType: " + reportType);
  }
  try {
    //add operating_unit_id param from localStorage
    const operatingUnitId = localStorage.getItem("selected_operating_unit_id");
    params = { ...params, operating_unit_id: operatingUnitId };
    const res = await api.get(url, { params });
    return {
      content: res.data.content || [],
      totalElements: res.data.totalElements || 0,
    };
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const initialState = {
  list: { content: [], totalElements: 0 },
  loading: false,
  error: null,
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message;
      });
  },
});

export default reportSlice.reducer;
